import React from 'react';

// GPS経路パス（SVGとアニメーションで共有）
const ROUTE = 'M70 260 C 220 120, 320 300, 470 170 S 700 90, 740 120';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// 案D：テック/DX メッシュグラデーション＋動くGPS経路
const TechMeshEffect = () => {
  const reduced = prefersReducedMotion();

  const styles = {
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      background: '#070b18',
    },
    mesh: {
      position: 'absolute',
      top: '-20%',
      left: '-20%',
      right: '-20%',
      bottom: '-20%',
      filter: 'blur(6px)',
      background: `
        radial-gradient(38% 50% at 22% 30%, rgba(37,99,235,0.85), transparent 60%),
        radial-gradient(36% 48% at 78% 26%, rgba(56,189,248,0.6), transparent 62%),
        radial-gradient(44% 55% at 68% 82%, rgba(124,92,246,0.7), transparent 60%),
        radial-gradient(40% 50% at 30% 88%, rgba(16,120,180,0.6), transparent 62%)
      `,
      animation: 'heroMeshDrift 16s ease-in-out infinite alternate',
    },
    route: {
      position: 'absolute',
      top: 0,
      left: 0,
    },
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes heroMeshDrift {
            from { transform: translate(-3%, -2%) scale(1.04); }
            to   { transform: translate(3%, 2%) scale(1.1); }
          }
          @keyframes heroRouteFlow {
            to { stroke-dashoffset: -120; }
          }
          @keyframes heroNodePulse {
            0%, 100% { opacity: 0.55; transform: scale(1); }
            50%      { opacity: 1;    transform: scale(1.35); }
          }
          .hero-tech-route {
            stroke-dasharray: 2 8;
            animation: heroRouteFlow 3s linear infinite;
          }
          .hero-tech-node {
            transform-box: fill-box;
            transform-origin: center;
            animation: heroNodePulse 2.6s ease-in-out infinite;
          }
          .hero-tech-node.n2 { animation-delay: 0.6s; }
          .hero-tech-node.n3 { animation-delay: 1.2s; }
          @media (prefers-reduced-motion: reduce) {
            .hero-tech-mesh,
            .hero-tech-route,
            .hero-tech-node { animation: none !important; }
          }
        `}
      </style>

      <div className="hero-tech-mesh" style={styles.mesh} />

      <svg
        style={styles.route}
        width="100%"
        height="100%"
        viewBox="0 0 800 340"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
      >
        <path
          id="heroRoutePath"
          className="hero-tech-route"
          d={ROUTE}
          fill="none"
          stroke="rgba(255,255,255,0.55)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle className="hero-tech-node n1" cx="70" cy="260" r="6" fill="#7fd7ff" />
        <circle className="hero-tech-node n2" cx="470" cy="170" r="5" fill="#ffffff" />
        <circle className="hero-tech-node n3" cx="740" cy="120" r="6" fill="#7fd7ff" />

        {/* 経路を進む光点（動きを抑える設定時は非表示） */}
        {!reduced && (
          <circle r="5" fill="#ffffff">
            <animateMotion dur="6s" repeatCount="indefinite" path={ROUTE} />
            <animate
              attributeName="opacity"
              values="0;1;1;0"
              keyTimes="0;0.1;0.9;1"
              dur="6s"
              repeatCount="indefinite"
            />
          </circle>
        )}
      </svg>
    </div>
  );
};

export default TechMeshEffect;
